export type HttpSslAuthCredentials = {
	ca?: string;
	cert?: string;
	key?: string;
	passphrase?: string;
};
